import React, { useEffect, useState, useCallback } from "react";
import { FlatList, StyleSheet, TouchableOpacity, View, Animated, useWindowDimensions, ImageBackground } from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import config from "../config/config";
import AppText from "../components/AppText";
import IconTouchable from "../components/IconTouchable";
import useUser from "../hooks/useUser";
import useProducts from "../hooks/useProducts";
import ListItemReskin from "../components/lists/ListItemReskin";
import Icon from "../components/Icon";
import ListItemSeperatorReskin from "../components/lists/ListItemSeperatorReskin";
import ScreenReskin from "../components/ScreenReskin";
import ListingCardReskin from "../components/ListingCardReskin";
import ListItemTextInputReskin from "../components/lists/ListItemTextInputReskin";

function DashboardScreenReskin({ navigation }) {
    const { user } = useUser();
    const { products, getProducts, loading } = useProducts();
    const [extraData, setExtraData] = useState(false);
    const [categories, setCategories] = useState();
    const [categoriesDropdown, setCategoriesDropdown] = useState(false);
    const [categoriesFilter, setCategoriesFilter] = useState(false);
    const [statusFilter, setStatusFilter] = useState(false);
    const [searchTerm, setSearchTerm] = useState();
    const [isOpen, setIsOpen] = useState(false);

    const window = useWindowDimensions();

    const [modalVisible, setModalVisible] = useState(false);

    const [selectedStatus, setSelectedStatus] = useState("for sale");
    const [selectedCategory, setSelectedCategory] = useState();
    const [rotateValue] = useState(new Animated.Value(0));

    useEffect(() => {
        getProducts();
    }, []);

    useEffect(() => {
        if (!products) {
            return;
        }
        setCategories([...new Set(products.map((product) => product.category))]);
    }, [products]);

    // Used to refresh the flatlist after new product data has been received.
    useFocusEffect(
        useCallback(() => {
            setExtraData(!extraData);
        }, [])
    );

    const handleMainButtonPress = (screen) => {
        rotateValue.setValue(0);
        Animated.timing(rotateValue, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
        }).start(() => navigation.navigate(screen));
    };

    return (
        <ScreenReskin
            title={selectedCategory}
            capitulize={true}
            subTitle={selectedStatus}
            navigation={navigation}
            loading={loading}
            showTitleBar={false}
            rightIconComponent={<IconTouchable name="tools" onPress={() => navigation.navigate("Tools")} />}
        >
            <View>
                <View style={{ flexDirection: "row" }}>
                    <View
                        style={{
                            width: "20%",
                            borderRightWidth: 2,
                            borderRightColor: "#EBEBEB",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <View style={{ alignItems: "center", justifyContent: "center" }}>
                            <IconTouchable
                                borderColor={config.colors.tertiary}
                                onPress={() => navigation.goBack()}
                                backgroundColor={config.colors.danger}
                                name={"home"}
                                size={40}
                            ></IconTouchable>
                        </View>
                    </View>
                    <View
                        style={{
                            justifyContent: "center",
                            flex: 1,
                            margin: 10,
                            shadowColor: "#171717",
                            shadowOffset: { width: 2, height: 4 },
                            shadowOpacity: 0.2,
                            shadowRadius: 3,
                        }}
                    >
                        <ListItemTextInputReskin
                            title="Search items"
                            onConfirm={true}
                            onChange={(searchTerm) => {
                                setSearchTerm(searchTerm);
                            }}
                        />
                    </View>
                    <View
                        style={{
                            width: "20%",
                            borderRightWidth: 2,
                            borderRightColor: "#EBEBEB",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <View style={{ alignItems: "center", justifyContent: "center" }}>
                            <IconTouchable
                                borderColor={config.colors.tertiary}
                                onPress={() => {
                                    navigation.navigate("Account");
                                }}
                                backgroundColor={config.colors.danger}
                                name={"head"}
                                size={40}
                            ></IconTouchable>
                        </View>
                    </View>
                </View>

                <ListItemSeperatorReskin />
                <View
                    style={{
                        flexDirection: "row",
                        height: window.height,
                        shadowColor: "#171717",
                        shadowOffset: { width: 2, height: 4 },
                        shadowOpacity: 0.2,
                        shadowRadius: 3,
                    }}
                >
                    <View style={[styles.filterContainer]}>
                        <ListItemReskin
                            title="For Sale"
                            // subTitle={products.filter((x) => x.status == "for sale").length}
                            IconComponent={<Icon name="form-select" iconColor={"#515152"} backgroundColor={"#F6F6F6"} />}
                            utilityComponent={
                                <View>
                                    <AppText>+</AppText>
                                </View>
                            }
                            onPress={() => {
                                setSelectedStatus("for sale");
                                setStatusFilter(true);
                            }}
                        ></ListItemReskin>

                        <ListItemReskin
                            title="Sold"
                            IconComponent={<Icon name="cash" iconColor={"#515152"} backgroundColor={"#F6F6F6"} />}
                            // subTitle={products.filter((x) => x.status == "sold").length}
                            utilityComponent={
                                <View>
                                    <AppText>+</AppText>
                                </View>
                            }
                            onPress={() => {
                                setSelectedStatus("sold");
                                setStatusFilter(true);
                            }}
                        ></ListItemReskin>

                        <ListItemReskin
                            title="Archive"
                            // subTitle={products.filter((x) => x.status == "archive").length}
                            IconComponent={<Icon name="map-marker" iconColor={"#515152"} backgroundColor={"#F6F6F6"} />}
                            utilityComponent={
                                <View>
                                    <AppText>+</AppText>
                                </View>
                            }
                            onPress={() => {
                                setSelectedStatus("archive");
                                setStatusFilter(true);
                            }}
                        ></ListItemReskin>

                        <ListItemReskin
                            title="Categories"
                            // subTitle={products.filter((x) => x.status == "archive").length}
                            IconComponent={<Icon name="map-marker" iconColor={"#515152"} backgroundColor={"#F6F6F6"} />}
                            utilityComponent={
                                isOpen ? (
                                    <View>
                                        <AppText>-</AppText>
                                    </View>
                                ) : (
                                    <View>
                                        <AppText>+</AppText>
                                    </View>
                                )
                            }
                            onPress={() => {
                                setCategoriesDropdown(!categoriesDropdown);
                                setIsOpen(!isOpen);
                            }}
                        ></ListItemReskin>

                        {categoriesDropdown &&
                            categories.map((category) => (
                                <ListItemReskin
                                    key={category}
                                    height={5}
                                    title={category}
                                    dropDown={true}
                                    utilityComponent={
                                        <View>
                                            <AppText>+</AppText>
                                        </View>
                                    }
                                    onPress={() => {
                                        setCategoriesFilter(true);
                                        setSelectedCategory(category);
                                        setModalVisible(false);
                                    }}
                                />
                            ))}

                        {/* <ListItemReskin
                            title="Archive"
                            // subTitle={products.filter((x) => x.status == "archive").length}
                            IconComponent={<Icon name="cog" iconColor={"#515152"} backgroundColor={"#F6F6F6"} />}
                            utilityComponent={
                                <View>
                                    <AppText>+</AppText>
                                </View>
                            }
                            onPress={() => {
                                setSelectedStatus("archive");
                                setStatusFilter(true);
                            }}
                        ></ListItemReskin> */}
                    </View>

                    <FlatList
                        data={
                            selectedCategory
                                ? products.filter((x) => x.category == selectedCategory).filter((y) => y.status == selectedStatus)
                                : products.filter((x) => x.status == selectedStatus)
                        }
                        key={window.width > 758 ? "h" : "v"}
                        numColumns={window.width > 758 ? 3 : 1}
                        extraData={extraData}
                        keyExtractor={(item) => item._id}
                        horizontal={false}
                        showsVerticalScrollIndicator={false}
                        ListHeaderComponent={
                            <View style={{ flexDirection: "row", flex: 1, paddingLeft: 15 }}>
                                {statusFilter && (
                                    <View
                                        style={{
                                            borderRadius: 20,
                                            backgroundColor: config.colors.red,
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textTransform: "uppercase",
                                            fontSize: 8,
                                            padding: 7,
                                            margin: 5,
                                            flexDirection: "row",
                                        }}
                                    >
                                        <AppText style={{ fontSize: 10, color: config.colors.white, fontWeight: "800", paddingRight: 5 }}>{selectedStatus}</AppText>
                                        <TouchableOpacity
                                            onPress={() => {
                                                setStatusFilter(false);
                                                setSelectedStatus("for sale");
                                            }}
                                        >
                                            <AppText style={{ fontSize: 12, color: config.colors.black, fontWeight: "800" }}>X</AppText>
                                        </TouchableOpacity>
                                    </View>
                                )}
                                {categoriesFilter && (
                                    <View
                                        style={{
                                            borderRadius: 20,
                                            backgroundColor: config.colors.red,
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textTransform: "uppercase",
                                            fontSize: 8,
                                            padding: 7,
                                            margin: 5,
                                            flexDirection: "row",
                                        }}
                                    >
                                        <AppText style={{ fontSize: 10, color: config.colors.white, fontWeight: "800", paddingRight: 5 }}>{selectedCategory}</AppText>
                                        <TouchableOpacity
                                            onPress={() => {
                                                setCategoriesFilter(false);
                                                setSelectedCategory("");
                                            }}
                                        >
                                            <AppText style={{ fontSize: 12, color: config.colors.black, fontWeight: "800" }}>X</AppText>
                                        </TouchableOpacity>
                                    </View>
                                )}
                            </View>
                        }
                        ListEmptyComponent={
                            <View style={{ alignItems: "center", paddingTop: 50 }}>
                                <AppText style={styles.selectorText} numberOfLines={1}>
                                    No Results,
                                </AppText>
                                <AppText>Please amend your search above</AppText>
                            </View>
                        }
                        renderItem={({ item }) => <ListingCardReskin product={item} navigation={navigation} />}
                    />
                </View>
            </View>

            <View style={{ position: "absolute", bottom: 0, width: "100%", alignItems: "center", justifyContent: "center" }}>
                <Animated.View
                    style={[
                        {
                            position: "absolute",
                            transform: [
                                {
                                    rotate: rotateValue.interpolate({
                                        inputRange: [0, 1],
                                        outputRange: ["0deg", "360deg"],
                                    }),
                                },
                            ],
                            borderRadius: 50,
                            bottom: 10,

                            zIndex: 3,
                        },
                    ]}
                >
                    <IconTouchable
                        name="plus"
                        borderColor={config.colors.tertiary}
                        backgroundColor={config.colors.danger}
                        onPress={() => handleMainButtonPress("NewProduct")}
                        actionBeforeAnimate={true}
                    />
                </Animated.View>
            </View>

            <View style={{ width: "20%", position: "absolute", bottom: 10, alignItems: "center", justifyContent: "center" }}>
                <IconTouchable
                    onPress={() => navigation.navigate("Tools")}
                    name="cog"
                    borderColor={"#F6F6F6"}
                    iconColor={"#515152"}
                    backgroundColor={"#F6F6F6"}
                    size={50}
                ></IconTouchable>
            </View>
            {/* <Modal animationType="fade" transparent={false} visible={modalVisible}>
                <SafeAreaView>
                    <ListItem title={"Categories"} />
                    <ListItem
                        title={"All"}
                        utilityComponent={<Icon name="arrow-right" iconColor={config.colors.tertiary} backgroundColor={config.colors.white} />}
                        onPress={() => {
                            setSelectedCategory(false);
                            setModalVisible(false);
                        }}
                    />
                    {categories &&
                        categories.map((category) => (
                            <ListItem
                                key={category}
                                title={category}
                                utilityComponent={<Icon name="arrow-right" iconColor={config.colors.tertiary} backgroundColor={config.colors.white} />}
                                onPress={() => {
                                    setSelectedCategory(category);
                                    setModalVisible(false);
                                }}
                            />
                        ))}
                    <View style={{ padding: 20 }}>
                        <IconTouchable
                            name="close"
                            size={30}
                            onPress={() => {
                                setExtraData(null);
                                setModalVisible(false);
                            }}
                        />
                    </View>
                </SafeAreaView>
            </Modal> */}
        </ScreenReskin>
    );
}

const styles = StyleSheet.create({
    filterContainer: {
        width: "20%",
        backgroundColor: "#F6F6F6",
        height: "100%",
        borderRightWidth: 2,
        borderColor: "#EBEBEB",
    },
    text: {
        alignSelf: "center",
        fontSize: 16,
        fontWeight: "900",
        color: config.colors.white,
        textTransform: "capitalize",
    },
    selectorIcons: {
        flexDirection: "row",
        justifyContent: "space-evenly",
        paddingVertical: 5,
    },
    typeSelectorIcons: {
        flexDirection: "row",
        justifyContent: "space-around",
        paddingBottom: 30,
    },
    buttonBoxLeft: {
        alignItems: "center",
        flexDirection: "row",
    },
    buttonBoxRight: {
        alignItems: "center",
        flexDirection: "row",
    },
    selector: {
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
        backgroundColor: config.colors.secondary,
        borderRadius: 5,
        paddingHorizontal: 10,
    },
});

export default DashboardScreenReskin;
